// object checks
export function isObject(o: any) {
  return (
    !!o &&
    o.constructor === Object &&
    Object.keys(o).length !== 0 &&
    typeof o !== "undefined"
  );
}

export function isObjectNotEmpty(obj: any) {
  return Object.keys(obj).length;
}

// is array?
export function isArray(obj: any) {
  return Array.isArray(obj);
}

// is email?
export function validateEmail(email: string) {
  if (!email) return false;
  const re = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,63})+$/;
  return re.test(email);
}

// is valid url?
export function validateURL(url: string) {
  const re =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/; // eslint-disable-line
  return re.test(url);
}

// has http/https protocol?
export function urlWithProtocol(url: string) {
  const re = /(http(s?)):\/\//i;
  return re.test(url);
}

// is a str JSON?
export function isJSON(str: string) {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
}

export function pluralise(count: number, str: string) {
  let strSuffix = "";
  if (count === 0 || count > 1) {
    strSuffix = "s";
  }
  return count + " " + str + strSuffix;
}

export function shuffleArray(array: []) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

export function interceptLinkClicks(event: MouseEvent): void {
  const target = event.target as HTMLElement;

  if (target.tagName === "A") {
    const link = target as HTMLAnchorElement;
    const href = link.getAttribute("href");

    if (
      href &&
      href.startsWith("/") &&
      !href.startsWith("//") &&
      event.button === 0 && // only left click
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey
    ) {
      event.preventDefault();
      navigateTo(href);
    }
  }
}

import moment from "moment";

export function isPlanExpiredState(
  daysAfter: number,
  compareEnd: string
): boolean {
  const dateCompare = moment(compareEnd, "YYYY-MM-DD").valueOf();
  const end = moment(dateCompare).add(daysAfter, "days").valueOf();
  const now = moment().valueOf();
  return now >= end;
}

export function isUserInRenewalState(
  daysBefore: number,
  daysAfter: number,
  compareEnd: string
): boolean {
  const dateCompare = moment(compareEnd, "YYYY-MM-DD").valueOf();
  const start = moment(dateCompare).subtract(daysBefore, "days").valueOf();
  const end = moment(dateCompare).add(daysAfter, "days").valueOf();
  const now = moment().valueOf();
  return now >= start && now <= end;
}

export function convertTaxAmount(
  price: number,
  taxAmount: number,
  countryId?: number
): number {
  return countryId === 17 ? price * ((100 + taxAmount) / 100) : price;
}

export function toCurrency(
  value: number,
  currencyType: string = "GBP"
): string | number {
  if (typeof value !== "number") return value;

  let formatter: Intl.NumberFormat;

  switch (currencyType) {
    case "USD":
      formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      break;

    case "GBP":
      formatter = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      break;

    case "EUR":
      formatter = new Intl.NumberFormat("en-IE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      break;

    default:
      formatter = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
  }

  return formatter.format(value);
}
